module.exports = __webpack_public_path__ + "static/media/welcome_4.f92e0b81.webp";